import { Button, Buttons, CancelButton, ModalCard } from '~/components';
import React from 'react';

function SendCreditNoteConfirmation({ creditNote, onResolve }) {
  return (
    <ModalCard title="Send Credit Note" onClose={() => onResolve(false)}>
      <ModalCard.Body>
        <p>
          Are you sure you want to send credit note #{creditNote.number} to <strong>{creditNote.client.name}</strong>?
        </p>
      </ModalCard.Body>

      <ModalCard.Footer>
        <Buttons align="right">
          <CancelButton onClick={() => onResolve(false)}>Cancel</CancelButton>
          <Button onClick={() => onResolve(true)}>Send</Button>
        </Buttons>
      </ModalCard.Footer>
    </ModalCard>
  );
}

export default SendCreditNoteConfirmation;
